export enum ApprovalType {
  MULTI_LEVEL = 'MULTI_LEVEL',
  BASIC = 'BASIC',
  BOOK_BUILDING = 'BOOK_BUILDING',
  NONE = 'NONE',
  KYC = 'KYC',
}
